﻿$.fn.dxChartPolarRepartClickVue = function custom_dxChartPolarRepartClickVue(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlchartpolarrepartclickvue dx-ctrl");
        this.createInstance(new cdxChartPolarRepartClickVue(this, option));
    }
    return this;
}

window.cdxChartPolarRepartClickVue = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.context_grid == 'undefined') option.context_grid = "datachartpolarrepartclickvue"
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid] = {}
    var para = function () { return option.bddCtrl.utiCourantParaJson[option.context_grid] }
    if (typeof para().polar_repart_vue_click_vue_detaille == 'undefined') para().polar_repart_vue_click_vue_detaille = false
    if (typeof para().polar_repart_vue_click_affiche_vue == 'undefined') para().polar_repart_vue_click_affiche_vue = true
    if (typeof para().polar_repart_vue_click_affiche_click == 'undefined') para().polar_repart_vue_click_affiche_click = true
    if (typeof para().polar_repart_vue_click_type == 'undefined') para().polar_repart_vue_click_type = "area"

    function mConstruit() {
        container.empty()
        container.css({ "height": "100%", "width": "100%" })
        Me.mUpdate()
    }

    // Change un parametre utilisateur puis rafraichit (uniquement si la valeur change vraiment)
    function mSetPara(name, value) {
        if (para()[name] === value) return
        para()[name] = value
        option.bddCtrl.mSaveParaJsonUtilisateur();
        Me.mUpdate()
    }

    var oldKey = null   // ds + parametres d'affichage du dernier rendu
    function mRempli(ds) {
        // Anti-boucle : si rien n'a change depuis le dernier rendu, on ne reconstruit pas
        var key = JSON.stringify({
            ds: ds,
            detaille: para().polar_repart_vue_click_vue_detaille,
            vue: para().polar_repart_vue_click_affiche_vue,
            click: para().polar_repart_vue_click_affiche_click,
            type: para().polar_repart_vue_click_type,
            w: Math.floor(container.innerWidth())
        })
        if (key === oldKey) return
        oldKey = key

        container.empty()

        // --- barre d'options (toujours affichee pour pouvoir changer les filtres) ---
        var $Table = $("<table style='width:100%'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        $("<td style='width:50%;'/>").appendTo($Tr)
        function addCheck(text, name) {
            var $Td = $("<td style='width:1px;padding-right:10px;'/>").appendTo($Tr)
            $("<div style='white-space:nowrap;'/>").appendTo($Td).dxCheckBox({
                text: text,
                value: para()[name],
                onValueChanged: function (e) {
                    if (!e.event) return   // ignore les changements programmatiques
                    mSetPara(name, e.value)
                },
                onContentReady: function (e) { $(e.element).find(".dx-checkbox-text").css({ "white-space": "nowrap", "font-family": "barlow condensed" }) }
            })
        }
        addCheck("Détaillé par jour", "polar_repart_vue_click_vue_detaille")
        addCheck("Afficher vues", "polar_repart_vue_click_affiche_vue")
        addCheck("Afficher clicks", "polar_repart_vue_click_affiche_click")
        var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxSwitch({
            switchedOffText: "Ligne",
            switchedOnText: "Aire   ",
            width: 55,
            value: (para().polar_repart_vue_click_type == "area"),
            onValueChanged: function (e) {
                if (!e.event) return
                mSetPara("polar_repart_vue_click_type", e.value ? "area" : "line")
            },
            onContentReady: function (e) {
                $(e.element).find(".dx-switch-on, .dx-switch-off").css({ "font-family": "barlow condensed" })
            }
        })
        $("<td style='width:50%;'/>").appendTo($Tr)

        // --- series a afficher ---
        var series = []
        if (para().polar_repart_vue_click_affiche_vue) series.push({ argumentField: "heure", valueField: 'nb_vue', name: 'Vues', color: "orange" })
        if (para().polar_repart_vue_click_affiche_click) series.push({ argumentField: "heure", valueField: 'nb_click', name: 'Clicks', color: "red" })

        // --- y a-t-il au moins une valeur non nulle dans les series affichees ? ---
        var hasData = ds.some(function (d) {
            return d.lst.some(function (o) {
                return (para().polar_repart_vue_click_affiche_vue && o.nb_vue > 0) ||
                    (para().polar_repart_vue_click_affiche_click && o.nb_click > 0)
            })
        })
        if (ds.length == 0 || series.length == 0 || !hasData) {
            // Un dxPolarChart sur un axe 0 -> 0 (ou sans serie) bug / boucle : on ne le cree pas
            $("<div style='text-align:center;padding:20px;'>(aucune vue/click)</div>").appendTo(container)
            return
        }

        // --- graphiques ---
        var nb = (ds.length == 2) ? 2 : 3
        var widthHeight = Math.floor(container.innerWidth() / nb) - 4   // marge anti retour a la ligne / scrollbar

        ds.forEach(function (data) {
            var $Div = $("<div style='width:" + (100 / nb) + "%;display:inline-block;vertical-align:top;'/>").appendTo(container)
            $("<div style='text-align:center;font-weight:bold;font-size:130%;font-variant:small-caps;'/>").text(data.title).appendTo($Div)
            $("<div style='width:100%;'/>").appendTo($Div).dxPolarChart({
                dataSource: data.lst,
                useSpiderWeb: false,
                size: { width: widthHeight, height: widthHeight },
                legend: { visible: false },
                series: series,
                valueAxis: { min: 0 },
                argumentAxis: { type: "discrete" },
                commonSeriesSettings: { type: para().polar_repart_vue_click_type },
                export: { enabled: false },
                tooltip: {
                    enabled: true,
                    container: container,
                    customizeTooltip: function (e) {
                        return { text: e.argumentText + "h - " + e.valueText + " " + e.seriesName };
                    }
                },
            });
        })
    }

    // Normalise le nom du jour renvoye par le serveur : "Lundi", "LUNDI", 1, "1"... -> "lundi"
    var JOURS = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
    function mJour(j) {
        if (j === null || typeof j == 'undefined') return ""
        if (typeof j == 'number' || /^\d+$/.test(String(j))) return JOURS[Number(j) % 7] || ""
        return String(j).trim().toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")
    }

    // Additionne vues/clicks par heure pour les jours donnes
    function mAgrege(lst, jours) {
        var res = []
        for (var i = 0; i <= 23; i++) res.push({ heure: i, nb_vue: 0, nb_click: 0 })
        lst.forEach(function (o) {
            if (jours.indexOf(mJour(o.jour)) == -1) return
            var h = Number(o.heure)
            if (!(h >= 0 && h <= 23)) return
            res[h].nb_vue += Number(o.nb_vue) || 0
            res[h].nb_click += Number(o.nb_click) || 0
        })
        return res
    }

    var requestId = 0
    this.mUpdate = function () {
        var myId = ++requestId
        option.bddCtrl.mAjaxCall({ command: "getrepartjournbvueclick", id_table_com: option.idTableCom, id_com: option.idCom }, function (data) {
            if (myId !== requestId) return   // reponse perimee : une requete plus recente est en cours
            var lst = (data && data.lstvueclickjour) || []
            var lstResult = []
            if (!para().polar_repart_vue_click_vue_detaille) {
                lstResult.push({ title: "Semaine", lst: mAgrege(lst, ["lundi", "mardi", "mercredi", "jeudi", "vendredi"]) })
                lstResult.push({ title: "Week-end", lst: mAgrege(lst, ["samedi", "dimanche"]) })
            } else {
                [["Lundi", "lundi"], ["Mardi", "mardi"], ["Mercredi", "mercredi"], ["Jeudi", "jeudi"],
                ["Vendredi", "vendredi"], ["Samedi", "samedi"], ["Dimanche", "dimanche"]].forEach(function (j) {
                    lstResult.push({ title: j[0], lst: mAgrege(lst, [j[1]]) })
                })
            }
            mRempli(lstResult)
        })
    }

    this.element = function () { return container }
    this.focus = function () { }

    mConstruit();
}